import styled from 'styled-components';
import { Button, ButtonProps } from 'basic-ui-lib';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(200px, 1fr));
  gap: 1rem;
`;
const argTypes: ButtonProps[] = [
  {
    type_primary: true,
    children: 'Primary Button',
    sm: true,
  },
  {
    type_primary: true,
    children: 'Primary Button',
    md: true,
  },
  {
    type_primary: true,
    children: 'Primary Button',
    lg: true,
  },
  {
    type_primary: true,
    children: 'Primary Button',
  },
  {
    type_primary: true,
    children: 'Primary Button',
    disabled: true,
  },
  {
    type_second: true,
    children: 'Secondary Button',
    sm: true,
  },
  {
    type_second: true,
    children: 'Secondary Button',
    md: true,
  },
  {
    type_second: true,
    children: 'Secondary Button',
    lg: true,
  },
  {
    type_second: true,
    children: 'Secondary Button',
  },
  {
    type_second: true,
    children: 'Secondary Button',
    disabled: true,
  },
  {
    type_light: true,
    children: 'Light Button',
    sm: true,
  },
  {
    type_light: true,
    children: 'Light Button',
    md: true,
  },
  {
    type_light: true,
    children: 'Light Button',
    lg: true,
  },
  {
    type_light: true,
    children: 'Light Button',
  },
  {
    type_light: true,
    children: 'Light Button',
    disabled: true,
  },
  {
    type_ghost: true,
    children: 'Ghost Button',
    sm: true,
  },
  {
    type_ghost: true,
    children: 'Ghost Button',
    md: true,
  },
  {
    type_ghost: true,
    children: 'Ghost Button',
    lg: true,
  },
  {
    type_ghost: true,
    children: 'Ghost Button',
  },
  {
    type_ghost: true,
    children: 'Ghost Button',
    disabled: true,
  },
  {
    type_cancel: true,
    children: 'Cancel Button',
    sm: true,
  },
  {
    type_cancel: true,
    children: 'Cancel Button',
    md: true,
  },
  {
    type_cancel: true,
    children: 'Cancel Button',
    lg: true,
  },
  {
    type_cancel: true,
    children: 'Cancel Button',
  },
  {
    type_cancel: true,
    children: 'Cancel Button',
    disabled: true,
  },
  {
    type_red: true,
    children: 'Red Button',
    sm: true,
  },
  {
    type_red: true,
    children: 'Red Button',
    md: true,
  },
  {
    type_red: true,
    children: 'Red Button',
    lg: true,
  },
  {
    type_red: true,
    children: 'Red Button',
  },
  {
    type_red: true,
    children: 'Red Button',
    disabled: true,
  },
  {
    type_delete: true,
    children: 'Delete Button',
    sm: true,
  },
  {
    type_delete: true,
    children: 'Delete Button',
    md: true,
  },
  {
    type_delete: true,
    children: 'Delete Button',
    lg: true,
  },
  {
    type_delete: true,
    children: 'Delete Button',
  },
  {
    type_delete: true,
    children: 'Delete Button',
    disabled: true,
  },
  {
    type_tertiary: true,
    children: 'Tertiary Button',
    sm: true,
  },
  {
    type_tertiary: true,
    children: 'Tertiary Button',
    md: true,
  },
  {
    type_tertiary: true,
    children: 'Tertiary Button',
    lg: true,
  },
  {
    type_tertiary: true,
    children: 'Tertiary Button',
  },
  {
    type_tertiary: true,
    children: 'Tertiary Button',
    disabled: true,
  },
  {
    type_new: true,
    children: 'New Button',
    sm: true,
  },
  {
    type_new: true,
    children: 'New Button',
    md: true,
  },
  {
    type_new: true,
    children: 'New Button',
    lg: true,
  },
  {
    type_new: true,
    children: 'New Button',
  },
  {
    type_new: true,
    children: 'New Button',
    disabled: true,
  },
];
export const ButtonStoryBoard = () => (
  <Container>
    {argTypes.map((arg, index) => (
      <Button key={index} {...arg} />
    ))}
  </Container>
);
